import React, { useState, useRef, useEffect } from 'react';
import styles from './styles.module.scss';

const SimpleButtonDropdown = ({
                          title,
                          items = [],
                          header,
                          drop = 'down', // 'up' | 'down'
                        }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const toggle = () => setOpen(prev => !prev);
  const close = () => setOpen(false);

  // close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        close();
      }
    };

    const handleEsc = (e) => {
      if (e.key === 'Escape') close();
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEsc);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, []);

  return (
    <div
      className={styles.wrapper}
      ref={ref}
    >
      {/* TOGGLE */}
      <div className={styles.toggle} onClick={toggle}>
        {title}
      </div>

      {/* MENU */}
      {open && (
        <div
          className={`${styles.menu} ${
            drop === 'up' ? styles.up : styles.down
          }`}
        >
          {header && <div className={styles.header}>{header}</div>}

          <div className={styles.items}>
            {items.map((item, index) => (
              <div
                key={index}
                className={`${styles.item} ${item.disabled ? styles.disabled : ''}`}
                onClick={() => {
                  if (!item.disabled) {
                    item.onClick?.();
                    close();
                  }
                }}
              >
                {item.itemContent}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SimpleButtonDropdown;